import * as actions from 'redux/actions/backlinkChecker.actions'
import * as userActions from 'redux/actions/user.actions'
import * as accountActions from 'redux/actions/account.actions'

const initialState = {
  loading: false,
  complete: false,
  results: null,
  url: '',
  pageRank: '-',
  domainRank: '-',
  backlinks: 0,
  backlinksDoFollow: 0,
  referringDomains: 0,
  referringIps: 0,
  previousResults: []
}

const backlinkCheckerReducer = (state = initialState, { type, payload = {} }) => {
  switch (type) {
    case actions.getResults.type:
    case actions.loadPrevious.type:
      return {
        ...state,
        loading: true,
        results: [],
      }

    case actions.getResultsNotReady.type:
    case actions.getResultsSuccess.type: 
    case actions.loadPreviousSuccess.type: {
      const {
        pageRank,
        domainRank,
        backlinks,
        backlinksDofollow,
        referringDomains,
        referringIps, 
        results
      } = payload?.data?.attributes || {}
      return {
        ...state,
        loading: false,
        complete: payload.complete,
        url: payload.url,
        pageRank: pageRank,
        domainRank: domainRank,
        backlinks: backlinks,
        backlinksDoFollow: backlinksDofollow,
        referringDomains: referringDomains,
        referringIps: referringIps,
        results: results,
      }
    }
    case actions.getResultsFailure.type:
    case actions.loadPreviousFailure.type:
      return {
        ...state,
        loading: false
      }

    case actions.getHistorySuccess.type:
      return {
        ...state,
        previousResults: payload.data?.length
          ? payload.data.sort((a, b) => (a.attributes.createdAt > b.attributes.createdAt ? -1 : 1))
          : []
      }

    case actions.resetResults.type:
      return {
        ...state,
        results: null
      }

    case actions.deleteHistoryItem.type: {
      return {
        ...state,
        previousResults: state.previousResults.filter(
          history => payload.historyId !== history.attributes.id
        )
      }
    }

    case 'ROUTE_CHANGE':
    case accountActions.getAccountDataFailure.type:
    case userActions.logout.type:
      return initialState

    default:
      return state
  }
}

export default backlinkCheckerReducer
